function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#1279BE",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M10.787 10.425l1.225 3.612h.013l1.162-3.612h1.676v5.262H13.7v-3.7l-1.262 3.7h-.9L10.287 12h-.013v3.688h-1.15v-5.263h1.662zm7.35 0c.238 0 .463.025.675.063.2.05.375.112.513.212.137.1.25.238.325.4.075.162.113.375.113.625 0 .263-.063.488-.176.662a1.163 1.163 0 0 1-.512.425 1.2 1.2 0 0 1 .7.488c.15.225.225.512.225.85a1.6 1.6 0 0 1-.15.7c-.1.188-.238.35-.4.475a1.75 1.75 0 0 1-.575.275 2.38 2.38 0 0 1-.675.088h-2.45v-5.263h2.387zm-9.787 0v.975h-1.6v4.275H5.588V11.4H4v-.975h4.35zm9.737 2.912h-1.224v1.45h1.2c.112 0 .212-.012.312-.037a.833.833 0 0 0 .262-.113.622.622 0 0 0 .188-.212c.05-.088.063-.2.063-.338 0-.262-.076-.462-.226-.575a.926.926 0 0 0-.575-.175zm-.187-2h-1.063v1.226H18c.2 0 .363-.05.488-.15.125-.1.187-.25.187-.476a.67.67 0 0 0-.063-.3.543.543 0 0 0-.425-.275 2.052 2.052 0 0 0-.287-.024zM9.938 8.064c.45 0 .824.374.837.837a.838.838 0 1 1-.838-.838zm4.112 0c.462 0 .837.374.837.837a.83.83 0 0 1-.837.838.83.83 0 0 1-.838-.838c0-.475.388-.838.838-.838z"
}));

var SvgIcTmb = function SvgIcTmb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTmb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_tmb.30347a6f.svg";
export { ForwardRef as ReactComponent };